// IMPORTS
import React, { useState, useEffect, useContext } from "react";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import { Grid, Stack, Typography, Drawer, Button, Box, TextField, Container, Chip, IconButton } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import RenderStatus from "./RenderStatus";
import { IMAGES_URL } from "Utils/URLs";
import { getDisplayUrl } from "Utils/mediaUrl";
import DriveWithUsState from "../Hooks/DriveWithUs.state";
import PartnerWithUsState from "../Hooks/PartnerWithUs.state";
import FreeRideState from "../Hooks/FreeRide.state";
import 'lightbox2/dist/css/lightbox.min.css';
import lightbox from 'lightbox2';
import $ from 'jquery';
import { UserContext } from "Hooks/UserContext";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { keyframes } from "@emotion/react"

const arrowAnimation = keyframes`
  0% {
    transform: translateX(0); /* Start at the original position */
  }
  50% {
    transform: translateX(-10px); /* Move left by 10px */
  }
  100% {
    transform: translateX(0); /* Back to the original position */
  }
`;

const styles = {
    details: {
        padding: "1rem",
        // borderTop: "1px solid #e1e1e1"
    },
    value: {
        padding: "1rem 2rem",
        borderBottom: "1px solid #e1e1e1",
        color: "#899499"
    }
};
const chipSX = {
    height: 24,
    padding: '0 6px'
};
const chipErrorSX = {
    ...chipSX,
    color: "#fff",
    backgroundColor: "orange",
    marginRight: '5px'
};

// const chipWarningSX = {
//   ...chipSX,
//   color: theme.palette.warning.dark,
//   backgroundColor: theme.palette.warning.light
// };

const chipSuccessSX = {
    ...chipSX,
    color: "#00ae48",
    backgroundColor: "#d8ffe3",
    height: 28
};

export default function NotificationCard(props) {
    const { formBusy, UpdateDriveWithUs, response, driveWithUsData, loading, GetDriveWithUs, oldData } = DriveWithUsState()
    const { GetPartnerWithUs, partnerWithUsData } = PartnerWithUsState()
    const { GetFreeRide, freeRideData } = FreeRideState()
    const [value, setValue] = React.useState("one");
    const [openDrawer, setOpenDrawer] = useState(false)
    const [drawerData, setDrawerData] = useState({})
    const [file, setFile] = useState("")
    const [expiry, setExipry] = useState("")
    const [imageUrl, setImageUrl] = useState("")
    const [partnerDrawer, setpartnerDrawer] = useState(false)
    const [fileError, setFileError] = useState({ error: false, errorMessage: "" })
    const [openImage, setOpenImage] = useState("")
    const [openModal, setOpenModal] = useState(false)
    const { notificationRes, notificcations } = useContext(UserContext)
    const navigate = useNavigate()

    function timeAgo(dateString) {
        const now = new Date();
        const date = new Date(dateString);
        const differenceInSeconds = Math.floor((now - date) / 1000);

        if (isNaN(differenceInSeconds) || differenceInSeconds < 0) {
            return "0 seconds ago";
        } else if (differenceInSeconds < 60) {
            return `${differenceInSeconds} seconds ago`;
        } else if (differenceInSeconds < 3600) {
            const minutes = Math.floor(differenceInSeconds / 60);
            return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
        } else if (differenceInSeconds < 86400) {
            const hours = Math.floor(differenceInSeconds / 3600);
            return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
        } else {
            const days = Math.floor(differenceInSeconds / 86400);
            return `${days} ${days === 1 ? 'day' : 'days'} ago`;
        }
    }



    const user = JSON.parse(localStorage.getItem("user"))

    useEffect(() => {
        lightbox.option({
            'resizeDuration': 200,
            'wrapAround': true,
        });
        
        setOpenDrawer(false)
    }, [response, notificationRes])





    const handleChange = (event, newValue) => {
        setValue(newValue);
    };



    return (
        <Card variant="outlined" sx={{ height: "100%", width: "100%" }}>
            {openModal && (
                <a
                    href={getDisplayUrl(openImage, IMAGES_URL)}
                    data-lightbox="gallery"
                    data-title="Image"
                    style={{ display: 'none' }}
                >
                    Open Image
                </a>
            )}



            <br></br>
            <Box display={"flex"} justifyContent={"space-between"} >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    textColor="#76a521"
                    indicatorColor="#76a521"
                    sx={{
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#76a521', // Custom indicator color
                        },
                        '& .MuiTab-root': {
                            color: '#76a521', // Custom text color
                            '&.Mui-selected': {
                                color: '#76a521', // Custom color for selected tab
                            },
                        },
                    }}
                >
                    <Tab value="one" label="Notifications" />
                </Tabs>
                <IconButton onClick={() => navigate("/driver_forms/profile")} sx={{ backgroundColor: "#FFF",marginRight:5, '&:hover': { backgroundColor: "#FFF" } }} >
                    <ArrowBack 
                    sx={{
                        animation: `${arrowAnimation} 1s infinite ease-in-out`,
                        marginRight: 1, // Space between icon and text
                    }} />
                    <Typography>Back to profile</Typography>
                </IconButton>
            </Box>
            <Divider></Divider>

            {/* MAIN CONTENT CONTAINER */}
            <form>
                <CardContent
                    sx={{
                        p: 3,

                        textAlign: { xs: "center", md: "start" }
                    }}
                >
                    {value === "one" ?


                        <>
                            {notificcations.map((item) => (
                                <Box sx={{ border: "solid 1px #e1e1e1" }} >
                                    <Grid container alignItems={"center"} >
                                        <Grid item xs={6} >
                                            <Box sx={{ display: "flex", alignItems: "center" }} >
                                                <Typography style={styles.details}>{item.name}</Typography>
                                                <Typography sx={{ fontSize: 12, color: "gray" }} >({timeAgo(item.created_at)})</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={6} textAlign={"end"} px={3} >
                                            <Chip label={item.status} sx={item.status === "unread" ? chipErrorSX : chipSuccessSX} />
                                        </Grid>
                                        <Grid item xs={12}  >
                                            <Typography style={styles.value}>{item.message}</Typography>
                                        </Grid>
                                    </Grid>



                                </Box>

                            ))

                            }
                        </>
                        : null}


                </CardContent>
            </form>
        </Card>
    );
}
